import { useQuery } from '@tanstack/react-query'

import { api } from '../../api/client'

/**
 * Доступ к ИИ-ассистенту. Ошибка (эндпоинта нет, сеть) = доступа нет: кнопку просто не показываем,
 * без повторов и без шума. Обновляем раз в 5 минут — админ мог включить/выключить ассистента.
 */
export function useAssistantAccess() {
  return useQuery({
    queryKey: ['assistant-access'],
    queryFn: api.assistantAccess,
    retry: false,
    staleTime: 5 * 60_000,
    refetchInterval: 5 * 60_000,
  })
}

/** Беседы текущего сотрудника — только когда панель открыта на списке. */
export function useAssistantConversations(enabled: boolean) {
  return useQuery({ queryKey: ['assistant-conversations'], queryFn: api.assistantConversations, enabled })
}
